import { render, staticRenderFns } from "./ButtonsReport.vue?vue&type=template&id=beecf7a0&scoped=true&"
import script from "./ButtonsReport.vue?vue&type=script&lang=js&"
export * from "./ButtonsReport.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsReport.vue?vue&type=style&index=0&id=beecf7a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beecf7a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VTooltip})
